import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

function MessageSystem({ content }) {
    const intl = useIntl();

    function getTransferMessage(messageContent) {
        if (messageContent.type !== "transfer") return null;

        const fromNames =
            messageContent.from.firstName && messageContent.from.lastName;

        return intl.formatMessage(
            fromNames
                ? {
                      id: "WEBMESSENGER.MESSAGE_SYSTEM.TRANSFER",
                      defaultMessage:
                          "Vous avez été transféré vers un autre conseiller",
                  }
                : {
                      id: "WEBMESSENGER.MESSAGE_SYSTEM.TRANSFER_AI_HUMAN",
                      defaultMessage:
                          "Vous avez été transféré vers un conseiller",
                  }
        );
    }

    return (
        <p
            className={classNames({
                "ek-chat__message--system-transfer":
                    content.type === "transfer",
            })}
        >
            {/**
             * Transfer case
             */}
            {getTransferMessage(content)}
        </p>
    );
}

MessageSystem.propTypes = {
    /**
     * Content
     */
    content: PropTypes.shape({
        type: PropTypes.string,
    }),
};

MessageSystem.defaultProps = {
    content: {
        type: "",
    },
};

export default MessageSystem;
